import qs from 'qs';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import './Pagination.scss';

const buildLink = ({ username, tag, page }) => {
  const query = qs.stringify({ tag, page });
  return username ? `/@${username}?${query}` : `/?${query}`;
};

//5페이지 단위 블록: 현재 페이지가 속한 블록의 페이지 번호들을 보여줌
const PAGE_BLOCK_SIZE = 5;

const Pagination = ({ page, lastPage, username, tag }) => {
  const blockStart =
    Math.floor((page - 1) / PAGE_BLOCK_SIZE) * PAGE_BLOCK_SIZE + 1;
  const blockEnd = Math.min(blockStart + PAGE_BLOCK_SIZE - 1, lastPage || 0);
  const pages = [];
  for (let p = blockStart; p <= blockEnd; p += 1) {
    pages.push(p);
  }

  return (
    <div className="Pagination">
      <Button
        disabled={page === 1}
        to={page === 1 ? undefined : buildLink({ username, tag, page: page - 1 })}
      >
        이전
      </Button>
      <div className="PageNums">
        {pages.map((p) =>
          p === page ? (
            <span className="PageNum current" key={p}>
              {p}
            </span>
          ) : (
            <Link className="PageNum" key={p} to={buildLink({ username, tag, page: p })}>
              {p}
            </Link>
          ),
        )}
      </div>
      <Button
        disabled={!lastPage || page >= lastPage}
        to={
          !lastPage || page >= lastPage
            ? undefined
            : buildLink({ username, tag, page: page + 1 })
        }
      >
        다음
      </Button>
    </div>
  );
};

export default Pagination;
